<div class="barra-progresso-container">
    <div class="barra-progresso" [style.background-color]="'#C4E7FE'">
      <div [matTooltip]="!exibirDisplayReal ? 'Real Produzido - ' + formatarValor(currentValue) + ' HA' : null"
      matTooltipPosition="above"
      [matTooltipDisabled]="exibirDisplayReal"
      class="barra-real" [style.width.%]="porcBarraReal" [style.background-color]="'#1e88e5'"></div>
  
      <div [matTooltip]="!exibirDisplayIdeal ? 'Esperado - ' + formatarValor(expectedValue) + ' HA' : null"
          matTooltipPosition="above"
          [matTooltipDisabled]="exibirDisplayIdeal"
          class="barra-ideal" [style.width.%]="porcBarraIdeal" [style.background-color]="'#76C6FF'"></div>
  
      @if (exibirDisplayIdeal) {
        <div class="marcador-meta ideal"
          [class.ajuste-direita]="porcBarraIdeal >= 95"
          [class.ajuste-esquerda]="porcBarraIdeal <= 5"
          [style.left.%]="porcBarraIdeal">
          Esperado
        </div>
      }
  
      @if (exibirDisplayReal) {
        <div class="marcador-meta real"
          [class.ajuste-direita]="porcBarraReal >= 95"
          [class.ajuste-esquerda]="porcBarraReal <= 5"
          [style.left.%]="porcBarraReal">
          <span>{{ formatarValor(currentValue) }} HA</span>
        </div>
      }
  
    </div>
    <div class="etiquetas">
      <span>0 HA</span>
      <span>{{ formatarValor(maxValue) }} HA</span>
    </div>
  </div>  